import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';

export default function Form({ 
  id, 
  children, 
  onSubmit, 
  className,
  defaultValues = {}
}) {
  const methods = useForm({ defaultValues });

  return (
    <FormProvider {...methods}>
      <form id={id} className={className} onSubmit={(e) => { e.stopPropagation(); methods.handleSubmit(onSubmit)(e); }}>
        {children}
        <button type="submit" hidden />
      </form>
    </FormProvider>
  );
}
